import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from 'actions';


class Portal extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    modal: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    isOpen: PropTypes.bool,
    className: PropTypes.string,
    root: PropTypes.oneOfType([
      PropTypes.instanceOf(Element),
      PropTypes.string,
    ]),
    onClose: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
    className: '',
    root: document.body,
    onClose: () => {},
  };

  constructor(props) {
    super(props);
    const { root } = props;
    if (typeof root === 'string') {
      this.root = document.querySelector(root);
    } else {
      this.root = root;
    }
    if (!this.root) {
      throw new Error('DOM container not found!');
    }
    this.portal = document.createElement('div');
    this.className = this.props.className;
    this.toggleScroll = ::this.toggleScroll;
    this.toggle = ::this.toggle;
    this.onClickOverlay = ::this.onClickOverlay;
  }

  componentDidMount() {
    // document.body.addEventListener('touchstart', this.toggleScroll, false);
    this.root.appendChild(this.portal);
    this.portal.className = this.className;
  }

  componentWillReceiveProps({ isOpen }) {
    if (this.root && this.portal) {
      this.toggle(isOpen);
    }
  }

  componentWillUnmount() {
    this.root.removeChild(this.portal);
    // document.body.removeEventListener('touchstart', this.toggleScroll, false);
  }

  toggleScroll(e) {
    const { isOpen } = this;
    if (isOpen) {
      e.preventDefault();
    }
  }

  toggle(isOpen) {
    if (isOpen) {
      this.portal.classList.add('is-open');
    } else {
      this.portal.classList.remove('is-open');
    }
  }

  onClickOverlay(e) {
    e.preventDefault();
    this.toggle(false);
    this.props.onClose(e);
  }

  get isOpen() {
    const modal = this.props.modal[this.props.id];
    if (modal) {
      return modal.isOpen;
    }
    return false;
  }

  get children() {
    return (
      <Fragment>
        <a
          href="#"
          className="portal__overlay"
          onClick={this.onClickOverlay}
        >
          &nbsp;
        </a>
        {this.props.children}
      </Fragment>
    );
  }

  render() {
    return this.isOpen ? createPortal(
      this.children,
      this.portal,
    ) : null;
  }
}

export default connect(
  state => ({
    modal: state.modal,
  }),
  dispatch => ({
    actions: bindActionCreators(actions.modal, dispatch),
  }),
)(Portal);
